import { Button, RoundBadge } from '@peacecover/component';
import { useGetBettieBalances } from '../../../domains/bettie/ui/hooks/useGetBettieBalances';

interface HeartPopupProps {
  onOpenNext: () => void;
  onClose: () => void;
  onOpenBettieSheet: () => void;
}

const HeartPopup = ({ onOpenNext, onClose, onOpenBettieSheet }: HeartPopupProps) => {
  const { data: bettieBalances, isLoading } = useGetBettieBalances();
  const currentHearts = bettieBalances?.bettiePoint?.balance ?? 0;
  return (
    <div className="fixed top-0 left-0 w-full h-full bg-black/50 z-[1000] flex items-center justify-center">
      <div className="bg-background-elevated rounded-[24px] px-[14px] pt-[32px] pb-[16px] w-[311px] flex flex-col gap-[36px] items-center">
        <div className="flex flex-col gap-[8px] items-center">
          <p className="text-[17px] font-bold leading-[20px] text-main-dark-2">
            프리뷰가 조금 더 남아있어요
          </p>
          <p className="text-[15px] leading-[18px] text-main-dark-4">
            남은 프리뷰를 보려면 하트가 필요해요
          </p>
        </div>
        <div className="flex flex-col gap-[12px] items-center">
          <img
            src="/assets/icons/graphic-3d/3D.like.png"
            alt="Like"
            className="w-[56px] h-[56px]"
          />
          <p className="text-[17px] font-bold leading-[20px] text-main-dark-2 text-center">
            하트 <span className="bg-gradient-single-red bg-clip-text text-transparent">2개</span>를
            사용해서
            <br />
            프리뷰 1개를 열어볼까요?
          </p>
        </div>
        <div className="px-[10px] w-full">
          <div className="flex items-center justify-between w-full px-[16px] py-[14px] rounded-full bg-separator-dark-1 border border-[rgba(255,255,255,0.60)]">
            <div className="flex items-center gap-[4px]">
              <img
                src="/assets/icons/graphic-3d/3D.like.png"
                alt="Like"
                className="w-[16px] h-[16px]"
              />
              <p className="text-[14px] font-medium leading-[17px] text-main-dark-3">
                보유 중인 하트
              </p>
              <p className="text-[14px] font-bold leading-[17px] text-main-dark-2">
                {isLoading ? '-' : currentHearts}개
              </p>
            </div>
            <button type="button" onClick={onOpenBettieSheet} className="flex items-center">
              <RoundBadge size="medium" className="bg-[#444] text-pure-white">
                구매하기
              </RoundBadge>
            </button>
          </div>
        </div>
        <div className="flex flex-col px-[8px] w-full">
          <Button
            size="large"
            className="w-full text-pure-white bg-primary-light font-semibold text-[17px]"
            onClick={onOpenNext}
          >
            열기
          </Button>
          <Button
            size="large"
            className="w-full text-primary-light bg-transparent font-semibold text-[17px]"
            onClick={onClose}
          >
            나중에
          </Button>
        </div>
      </div>
    </div>
  );
};

export default HeartPopup;
